import defaultTexts from '../domain/__fixtures__/defaultConfigValues/defaultTexts'
import { Localization } from '../domain/types/config'
import type { ITextLibrary } from '../domain/types/config'

/**
 * cinnamon's default copy library, promoted from test fixture to public API.
 *
 * It was ported under `domain/__fixtures__/` because at the time its only job
 * was keeping the promotion tests' inputs byte-identical. Then the live config
 * endpoint turned out to serve **no `texts` at all** — cinnamon merges these
 * defaults at runtime — so without them `config.texts.promotions.someKey` reads
 * undefined and every promotion message renders blank. That makes this
 * production data. The files stay where they are, verbatim; this is the surface.
 */
export { Localization }

const FALLBACK = Localization.En

const isLocalization = (value: string): value is Localization =>
  (Object.values(Localization) as string[]).includes(value)

/**
 * @param locale a config's `localization` / `locale`, in whatever case it was
 *   authored. `Localization`'s members are lowercase (`es-mx`), while a config
 *   or a BCP 47 tag may say `es-MX`.
 *
 * An unknown locale falls back to English rather than to an empty library: a
 * storefront with the wrong language is legible, one with no copy is not.
 */
export const defaultTextsFor = (locale: string): ITextLibrary => {
  const normalised = locale.toLowerCase()
  const key = isLocalization(normalised) ? normalised : FALLBACK
  return defaultTexts[key] as ITextLibrary
}

export const DEFAULT_TEXT_NAMESPACES = Object.keys(
  defaultTexts[FALLBACK],
) as readonly string[]
